import { makeAutoObservable } from "mobx"
import Document from "./Document"
import CampaignFolder from "./CampaignFolder"

export default class Campaign {
  
  constructor(campaign={}) {
    this.id = campaign.id
    this.name = campaign.name || ''
    this.project_number = campaign.project_number
    this.owner_name = campaign.owner_name || ''
    this.owner_avatar = campaign.owner_avatar || ''
    this.owner_email = campaign.owner_email || ''
    this.image = campaign.image || ''
    this.description = campaign.description || ''
    this.sharing_token = campaign.sharing_token || ''
    this.password = campaign.password || ''
    this.client_id = campaign.client_id || campaign.client?.id
    this.client_name = campaign.client_name
    this.client_image = campaign.client_image || ''
    this.theme_color = campaign.theme_color
    this.action_count_target = campaign.action_count_target || 0
    this.influencer_target = campaign.influencer_target || 0
    this.influencer_budget = campaign.influencer_budget || 0
    this.gross_reach_target = campaign.gross_reach_target || 0
    this.net_reach_target = campaign.net_reach_target || 0
    this.action_count_target = campaign.action_count_target || 0
    this.impressions_target = campaign.impressions_target || 0
    this.cpm_target = campaign.cpm_target || 0 // TODO development frontend and backend, only done on the budget table overview
    this.social_budget = campaign.social_budget || 0
    this.show_report = campaign.show_report || false
    this.media_budget = campaign.media_budget || 0
    this.travel_cost_enabled = campaign.travel_cost_enabled || false
    this.travel_cost_target = campaign.travel_cost_target || 0
    this.attendance_cost_enabled = campaign.attendance_cost_enabled || false
    this.attendance_cost_target = campaign.attendance_cost_target || 0
    this.currency = campaign.currency || 'EUR'
    this.currency_symbol = campaign.currency_symbol || '€'
    this.budget_table_visible = !!campaign.budget_table_visible
    this.platforms = new Set(campaign.platforms || [])
    this.collaborators = campaign.collaborators || []
    this.statuses = campaign.statuses || []
    this.created_at = campaign.created_at || ''
    this.start_date = campaign.start_date || ''
    this.end_date = campaign.end_date || ''
    this.archived_at = campaign.archived_at || null

    this.documents = campaign.documents?.map(document => new Document(document)) || []
    this.campaign_folders = campaign.campaign_folders?.map(campaignFolder => new CampaignFolder(campaignFolder)) || []
    this.custom_fields = campaign.custom_fields || []

    makeAutoObservable(this)
  }
}
